import React, { FC } from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../../../theme';
import ListOption from '../ListOption/ListOption';
import { FareGroupOption } from '../../../../model/types';

export interface Props {
	className?: string;
	options: FareGroupOption[];
}

const ListOptions: FC<Props> = ({ className, options }) => {
	const { ListOptions: css } = useTheme('Entities').FareGroupV2;

	return (
		<div className={cn(css.root, className)}>
			{options.map((option, index) => (
				<ListOption key={index} className={css.option} {...option} />
			))}
		</div>
	);
};

export default ListOptions;
